import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import s from './AListIcon.module.scss';

function AListIcon(props) {
  const { className, rewardList, ...restOfProps } = props;

  return (
    <div className={cn(s.container, s[className])} data-list={rewardList} {...restOfProps}>
      <svg
        className={s.svg}
        width="50"
        height="50"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          r="22"
          cx="25"
          cy="25"
          fill="#ad1f2e"
          stroke="#ad1f2e"
          strokeWidth="1"
          strokeDasharray="138.23"
          strokeDashoffset="0"
        />
      </svg>
    </div>
  );
}

AListIcon.propTypes = {
  className: PropTypes.string,
  rewardList: PropTypes.string,
};

AListIcon.defaultProps = {
  className: null,
  rewardList: 'A',
};

export default AListIcon;
